var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import pubsub from "@viewlift/pubsub";
import { handleStatusGaCalls } from '../../../helpers';
import { ANALYTICSEVENTS } from '../../LoginV2/Helpers/analyticsMap';
import { parseJSON } from '../../utils/parseJSON';
// import './style.scss'
var StripeInputEl = function (_a) {
    var _b, _c, _d, _e;
    var El = _a.El, theme = _a.theme, style = _a.style, title = _a.title, moduleData = _a.moduleData, isCvc = _a.isCvc, isDisabled = _a.isDisabled;
    var _f = __read(useState(false), 2), valid = _f[0], setValid = _f[1];
    var _g = __read(useState(false), 2), titleHead = _g[0], setTitleHead = _g[1];
    var debounceTimer;
    var verifyInputs = function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
            var isCompleted = document.getElementsByClassName("StripeElement StripeElement--complete");
            if (isCompleted.length == 3) {
                var checkoutInitPageDetails = parseJSON(sessionStorage.getItem('checkoutInitPageData'));
                // event for card added
                var cardAddedStatus = {
                    "pageUrl": checkoutInitPageDetails === null || checkoutInitPageDetails === void 0 ? void 0 : checkoutInitPageDetails.pageUrl,
                    status: "success"
                };
                pubsub.publish("stripeComplete", true);
                pubsub.publish('user-analytics', { ename: ANALYTICSEVENTS.CARD_ADDED, data: cardAddedStatus });
                handleStatusGaCalls({ eventName: 'card_added', subSection: 'payment', type: 'cardAdded', reason: null, status: null, additionalLabel: null, action: 'Add Card', paymentStatus: null, eventCategory: 'Payment', section: 'checkout' });
            }
            else {
                pubsub.publish("stripeComplete", false);
            }
        }, 500);
    };
    var disabledColour = "rgb(183 186 194)";
    var inputStyle = {
        background: ((_c = (_b = moduleData === null || moduleData === void 0 ? void 0 : moduleData.layout) === null || _b === void 0 ? void 0 : _b.settings) === null || _c === void 0 ? void 0 : _c.inputColor) || "#fff",
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "stripe-input title-head ".concat(titleHead ? "title-head" : "", " ").concat(valid ? ' ticked site-color-before' : '', " ").concat(isCvc ? "cvc-input" : ""), style: isDisabled ? { background: disabledColour } : inputStyle },
            React.createElement(El, { options: {
                    placeholder: title || '',
                    style: {
                        base: {
                            color: ((_e = (_d = moduleData === null || moduleData === void 0 ? void 0 : moduleData.layout) === null || _d === void 0 ? void 0 : _d.settings) === null || _e === void 0 ? void 0 : _e.cardTextColor) || "#000",
                            fontSize: "14px",
                            '::placeholder': {
                                color: 'rgba(89, 93, 102, 1)',
                            }
                        }
                    }
                }, onBlur: function (e) { return verifyInputs(); }, onChange: function (e) { return verifyInputs(); } }))));
};
export default StripeInputEl;
